import Button from '../../juristec-ui/core/Button';
import IconButton from '../../juristec-ui/core/IconButton';
import Tooltip from '../../juristec-ui/core/Tooltip';
import { AddStory } from '../../juristec-ui/icons';
import PlanItem from './PlanItem';
import PlanTable from './PlanTable';

import {
  ContractedPlanContainer,
  ScrollContainer,
  PlanHeader,
} from './styled/ContractedPlan.styled';

interface ContractedPlanProps {
  planInfo?: Array<PlanItem>;
  openPlans?: () => void;
}

const defaultProps = {
  planInfo: [],
  openPlans: () => {},
};

/**
 * A component to display the instance plan info
 */
const ContractedPlan = ({
  planInfo = defaultProps.planInfo,
  openPlans = defaultProps.openPlans,
}: ContractedPlanProps) => (
  <ContractedPlanContainer>
    <PlanHeader>
      <h3>Plano Atual Contratado</h3>
      <Tooltip text="Todos os planos disponíveis" className="plans-tooltip" direction="top">
        <IconButton variant="pattern" onClick={openPlans} size="medium" shape="rounded">
          <AddStory />
        </IconButton>
      </Tooltip>
    </PlanHeader>
    <ScrollContainer>
      <PlanTable planInfo={planInfo} />
    </ScrollContainer>
  </ContractedPlanContainer>
);

export default ContractedPlan;
